<template>
<div id="PartSaleInvoiceView">
    <div class="loader" v-show="loading"></div>
    <div class="web-right-sidebar"> <!--right sidebar-->
        <div class="right-asset-tab-list purchase-order-right-tab">
            <div id="tabs" class="containerTab">
                <div class="tabs">
                    <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">Invoice Details</a>
                    <a v-on:click="activityLogs()" v-bind:class="[ activetab === 2 ? 'active' : '' ]">Activity</a>
                </div>
                <div class="content">
                    <div v-show="activetab === 1" class="tabcontent">
                        <div class="list-view">
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                                <label class="col">Invoice Type :</label>
                                <span class="col">{{invoice_type}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                                <label class="col">Invoice #:</label>
                                <span class="col">{{invoice_number}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <!-- <span class="work-order-icon"> <i class="hi-icon icon-flman-user"></i> </span> -->
                                <label class="col">Customer :</label>
                                <span class="col">{{customer}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                                <label class="col">Terms :</label>
                                <span class="col">{{terms}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                                <label class="col">PO# :</label>
                                <span class="col">{{po_no}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <!-- <span class="work-order-icon"> <i class="hi-icon icon-flcalendar2"></i> </span> -->
                                <label class="col">Invoice Date :</label>
                                <span class="col">{{invoice_date}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <!-- <span class="work-order-icon"> <i class="hi-icon icon-flcalendar2"></i> </span> -->
                                <label class="col">Due Date :</label>
                                <span class="col">{{due_date}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <!-- <span class="work-order-icon"> <i class="hi-icon icon-flcalendar2"></i> </span> -->
                                <label class="col">Status :</label>
                                <span class="col">{{status}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                                <label class="col">Location :</label>
                                <span class="col">{{location}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                                <label class="col">Note :</label>
                                <span class="col">{{note}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <label class="col">Created Date :</label>
                                <span class="col">{{created_at}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <label class="col">Open Amount :</label>
                                <span class="col">{{open_amount}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <label class="col">Total Amount :</label>
                                <span class="col">{{total_amount}}</span>
                            </div>
                        </div>
                    </div>
                    <div v-show="activetab === 2" class="tabcontent" id="customer-activity-logs" >
                        <invoice-activity-log-list :activityLogVal="activityLogsTabValue"></invoice-activity-log-list>
                    </div>
                </div>
            </div>
        </div>
    </div> <!--right sidebar-->

    <div id="page-content-wrapper" class="admin-content-area purchase-order-left-section">
        <template v-if="cantAccessPage === true">
            <div class="page-name asset-view-page-name purchase-order-title">
                <div class="page-title"> # {{invoice_number}}</div>
                <div class="web-action-btn btn-groups text-right">
                    <button type="button" v-if="canAddCrm" class="btn btn-secondary" v-on:click="crmSection()" >
                        <i class="fp-agreement"> </i> {{crmBtnTitle}}
                    </button>
                    <template v-if="!isCrmSection">
                    <button type="submit" id="previewInvoiceBtn" v-on:click="previewInvoice()" class="btn btn-secondary"><i class="fp-invoice"></i> Preview Invoice
                    </button>
                     <button type="submit" id="editInvoiceBtn" v-on:click="generateInvoicePdf()" class="btn btn-secondary"><i class="fp-download"></i> Download PDF
                    </button>
                    <button v-if="invoice_status.toLowerCase() == 'draft'" type="submit" id="editInvoiceBtn" v-on:click="editInvoice()" class="btn btn-primary"><i class="fp-edit-icon"></i> Edit
                    </button>
                    <template v-if="canListInvoice == true">
                        <!-- <router-link class="btn btn-secondary" v-bind:to="{name: 'ListInvoice'}"> <i class="fp-back"></i> Back</router-link> -->
                        <button type="submit" class="btn btn-secondary" v-on:click.prevent="backInvoiceList" >
                        <i class="fp-back"> </i>    Back
                    </button>
                    </template>
                    </template>
                </div>
                <div class="mobile-action-btn elipse-btn">
                    <button type="submit" id="editInvoiceBtn" v-on:click="editInvoice()" class="btn btn-primary"><i class="fp-edit-icon"></i> Edit
                    </button>
                    <template v-if="canListInvoice == true">
                        <!-- <router-link class="btn btn-secondary" v-bind:to="{name: 'ListInvoice'}"> <i class="fp-back"></i> Back</router-link> -->
                        <button type="submit" class="btn btn-secondary" v-on:click.prevent="backInvoiceList" >
                        <i class="fp-back"> </i>    Back
                        </button>
                    </template>
                    <button type="button" class="btn btn-elipse" data-toggle="dropdown" data-toggle-position="left" aria-expanded="false" v-on:click.prevent="myFunction">
                        <i class="fp-ellipsis-v"></i>
                    </button>
                    <div id="myDropdown" class="dropdown-content">
                        <ul>
                            <li v-if="canAddCrm"><a  class="" href="javascript:void(0);" v-on:click="crmSection()" > CRM</a></li>
                            <li><a id="previewInvoiceBtn" v-on:click="previewInvoice()" class=""> Preview Invoice</a></li>
                            <li><button type="submit" id="editInvoiceBtn" v-on:click="generateInvoicePdf()" class=""> Download PDF</button></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="container-fluid">
                <div id="workorder-detail work-order-view-top" class="admin-page-content part-sale-invoice-view">
                    <template v-if="!isCrmSection">
                    <section class="internal-container border-top-table-fl">
                        <template v-if="invoiceItemsArr.length == 0 || invoiceItemsArr == undefined">
                            <div class="lineitem-main-section">
                            <h5>No Line Item Added</h5>
                            </div>
                        </template>
                        <template v-else>
                            <div class="table-responsive-sm">
                                <table id="contact_table" class="table table-sm table-bordered font-1" v-if="invoiceItemsArr != undefined && invoiceItemsArr.length > 0">
                                    <thead>
                                        <tr class="table-primary">
                                            <!-- <th>GL Account</th>
                                            <th>Description</th> -->
                                            <th>Part Name</th>
                                            <th>Description</th>
                                            <th class="text-right">Quantity</th>
                                            <th class="text-right">Unit Price</th>
                                            <th class="text-right">Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in invoiceItemsArr" v-bind:key="index">
                                            <td> {{ item.part}} </td>
                                            <td> {{ item.description}} </td>
                                            <td class="text-right"> {{ item.quantity}} </td>
                                            <td class="text-right"> {{ item.unit_price}} </td>
                                            <td class="text-right"> {{ item.total}} </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </template>
                    </section>
                    <div class="order-summary mt-4"> <!--Description section-->
                        <div class="row">
                            <div class="col-md-6 offset-md-6">
                                <div class="bg-white radius-5 p-3">
                                    <label class="font-bold"> SUMMARY </label>
                                    <table class="table table-sm table-bordered">
                                        <tr class="table-secondary">
                                            <td> Subtotal: </td>
                                            <td class="text-right"> {{sub_total}} </td>
                                        </tr>
                                        <tr>
                                            <td> Tax: </td>
                                            <td class="text-right discount-order-box">
                                            {{tax_amount}}</td>
                                        </tr>
                                        <tr class="table-secondary">
                                            <td> Total: </td>
                                            <td class="order-total text-right"> {{total}} </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section class="internal-container border-top-table-fl mt-4 loader-position">
                        <div class="loader-div" v-show="glLoading"></div>
                        <div class="journal-title">
                            <h5> General Ledger <i class="fp-down-arrow cursor-pointer" data-toggle="collapse" :data-target="'#demo'"></i> </h5>
                        </div>
                        <div :id="'demo'" class="accordian-body collapse show">
                            <div class="table-responsive-sm">
                                <table id="contact_table" class="table table-bordered table-sm font-1">
                                    <thead>
                                        <tr class="table-primary">
                                            <th>Account</th>
                                            <th class="text-right">Debit</th>
                                            <th class="text-right">Credit</th>
                                            <th class="text-right">Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="glArr != undefined && glArr.length > 0">
                                        <template v-for="(journalItem , journalKey) in glArr">
                                            <tr :key="'journal'+journalKey">
                                                <template v-if="journalItem.account_description == 'Total'">
                                                    <td class="text-right">{{journalItem.account_description}}</td>
                                                </template>
                                                <template v-else>
                                                    <td>{{journalItem.account_description}}</td>
                                                </template>
                                                <td class="text-right">{{journalItem.debit}}</td>
                                                <td class="text-right">{{journalItem.credit}}</td>
                                                <td class="text-right">{{journalItem.journal_amount}}</td>
                                            </tr>
                                        </template>
                                    </tbody>
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="4"><h5>No GL Found</h5></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </section>
                    </template>
                    <template v-else>
                        <!-- Invoice Crm -->
                        <div id="invoice-crm-list" class="admin-page-content invoice-view list-view">
                            <template v-if="crmAdd">
                                <crm-create :fromModule="invoiceObj"></crm-create>
                            </template>
                            <template v-else>
                                <button v-if="canAddCrm" type="submit" class="btn btn-primary pull-right" v-on:click.prevent="addCrm"><i class="fp-add"> </i>Add</button>
                                <section class="internal-container border-top-table-fl" style="margin-top:40px !important;">
                                    <div class="bg-white data-table p-0">
                                        <invoice-crm-list v-if="enableInvoiceCrm" :moduleVal="'invoice'" :moduleId="invoiceId"></invoice-crm-list>
                                    </div>
                                </section>
                            </template>
                        </div>
                    </template>
                </div>
            </div>
        </template>
        <template v-else-if="cantAccessPage === false">
            <div class="container-fluid">
                <div class="bg-white text-center">
                    <h1>Oops!</h1>
                    <h2>403</h2>
                    <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                </div>
            </div>
        </template>
        <template v-else>
            <loading-content></loading-content>
        </template>
        <app-footer></app-footer>
        <!--tab content-->
        <!--tab content-->
    </div>
</div>
</template>
<script>
import Vue from 'vue';

import LoadingContent from "@/components/LoadingContent.vue";
import {commonMixins} from '../../mixins/commonMixins';
import ActivityLogListView from '@/components/ActivityLogList.vue';
Vue.component("loading-content", LoadingContent);
Vue.component("invoice-activity-log-list", ActivityLogListView);
import CrmCreate from "@/components/CrmCreate.vue";
Vue.component("crm-create", CrmCreate);
export default {
    name: "PartSaleInvoiceView",
    components: {
        appFooter: () => import('@/components/Footer'),
        invoiceCrmList: () => import('@/components/CrmList.vue')
    },
    mixins:[commonMixins],
    data: () => ({
        invoiceItemsArr:[],
        loading:false,
        glLoading:false,
        permissions:[],
        cantAccessPage:"",
        canListInvoice:false,
        invoiceId : 0,
        activetab: 1,
        invoice_number:'',
        invoice_date:'',
        due_date:'',
        customer:'',
        terms:'',
        po_no:'',
        invoice_type:'',
        sub_total:'',
        tax_amount:'',
        total:'',
        activityLogsTabValue: "invoiceloadList",
        invoice_status:'',
        location:'',
        glArr:[],
        isCrmSection:false,
        enableInvoiceCrm:false,
        canAddCrm:false,
        crmAdd:false,
        invoiceObj:{},
        crmBtnTitle:"CRM",
        fromUrl:"",
        from:"",
        status:"",
        created_at : '',
        note:"",
        open_amount:'',
        total_amount:''
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'view_invoice') {
                    self.cantAccessPage = true;
                }
                if(permissions.name == 'list_invoice') {
                    self.canListInvoice = true;
                }
                if (permissions.name == 'add_crm') {
                    self.canAddCrm = true;
                }
            });
            if(self.cantAccessPage == ''){
                self.cantAccessPage = false;
            }
        }
    },
    mounted: function() {
        var self = this;
        if(this.$route.query.fromUrl != undefined && this.$route.query.fromUrl != ""){
          self.fromUrl = atob(this.$route.query.fromUrl);
        }
        if(this.$route.query.from == "customer"){
          self.from = this.$route.query.from;
        }
        self.invoiceId = this.$route.params.id.toString();
        //set value in invoice object for crm
        self.invoiceObj.module = "invoice";
        self.invoiceObj.invoice_id = this.$route.params.id;
        self.invoiceObj.flag = "add";
        self.invoiceObj.crm_id = "";
        self.getPermissions();
        self.loadInvoiceData();
    },
    metaInfo() {
        return {
            title: (this.invoice_number != "") ? this.invoice_number + " | Customer Invoice View | " +process.env.COPYRIGHT_NAME:"Customer Invoice View | " +process.env.COPYRIGHT_NAME
        }
    },
    methods : {
        backBtn(){
            var self = this;
            self.$router.push("/invoice/list");
        },
        editInvoice() {
            var self = this;
            self.$router.push("/invoice/edit/" + self.invoiceId);
        },
        loadInvoiceData() {
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/invoice/part-sale/details",
                type: "GET",
                headers: {
                    Accept: "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Authorization": "Bearer " + localStorage.getItem("tkn"),
                    "Access-Control-Allow-Headers":
                        "Origin, Content-Type, Authorization,X-Requested-With",
                    "Cache-Control": "no-cache"
                },
                dataType: "json",
                data:{'invoice_id':self.invoiceId},
                success: function (data) {
                    self.loading = false;

                    if (data.status == "success") {
                        self.invoiceObj.customer_id = data.content.customer_id;
                        self.invoice_number = data.content.invoice_number;
                        self.customer = data.content.customer;
                        self.invoice_date = data.content.invoice_date;
                        self.due_date = data.content.due_date;
                        self.created_at = data.content.created_at;
                        self.open_amount = data.content.open_amount;
                        self.total_amount = data.content.total;
                        self.invoice_status = data.content.status;
                        self.note = data.content.note;
                        if (data.content.cpo_number != null) {
                            self.po_no = data.content.cpo_number;
                        }else{
                            self.po_no = "-";
                        }
                        if (data.content.term_name != null) {
                            self.terms = data.content.term_name;
                        }else{
                            self.terms = "-";
                        }
                        if (data.content.location_name != null && data.content.location_name != "") {
                            self.location = data.content.location_code + " | " + data.content.location_name;
                        }else{
                            self.location = "-";
                        }
                        self.invoice_type = data.content.invoice_type;
                        self.sub_total = data.content.sub_total;
                        self.tax_amount = data.content.tax_amount;
                        self.total = data.content.total;
                        self.status = data.content.status;
                        if (data.content.items != undefined) {
                            self.invoiceItemsArr = data.content.items;
                            console.log("invoice items =>",self.invoiceItemsArr);
                        }else{
                            self.invoiceItemsArr = [];
                        }
                        // if (data.content.journals != undefined) {
                        //     self.glArr = data.content.journals;
                        // }else{
                        //     self.glArr = [];
                        // }
                        self.getGLEntry(data.content.invoice_number);
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'part-sale-invoice-details');
                }
            });
        },
        getGLEntry(invNo) {

            var self = this;
            self.glLoading = true;
            $.ajax({
                url: process.env.ROOT_API + "/module/gl",
                type: "POST",
                headers: {
                    Accept: "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Authorization": "Bearer " + localStorage.getItem("tkn"),
                    "Access-Control-Allow-Headers":
                        "Origin, Content-Type, Authorization,X-Requested-With",
                    "Cache-Control": "no-cache"
                },
                dataType: "json",
                data:{'id':self.invoiceId,'doc_no':invNo,'name':'customer invoice'},
                success: function (data) {
                    self.glLoading = false;
                    if (data.status == "success") {
                        self.glArr = data.content;
                    }
                },
                error: function (jqXHR, exception) {
                    self.glLoading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'workorder-invoice-view');
                }
            });
        },
        activityLogs(){

          var self = this;
        //   var path = window.location.pathname;
        //   var segments = path.split("/");

          self.$root.$emit('activity_log_opted','invoice',self.invoiceId);
          self.activityLogsTabValue = "invoiceloadList";     // flag value set to loadList so that filters in list work properly.
          self.activetab = 2;
        },
        generateInvoicePdf(){

            var self = this;

            self.loading = true ;
            $.ajax({
                url: process.env.ROOT_API + "/invoice/pdf",
                type: "POST",
                data: {
                    invoice_id:self.invoiceId,
                    invoice_type:self.invoice_type,
                    invoice_origin:"manual"
                },
                headers: {
                    'Accept': 'application/json',
                    "Access-Control-Allow-Origin": '*',
                    "Authorization": "Bearer " + localStorage.getItem("tkn"),
                    'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                    "Cache-Control": "no-cache"
                },
                dataType: 'json',
                success: function (data) {
                    self.loading = false ;
                    if (data.status == 'success'){
                        var link = document.createElement('a');
                        document.body.appendChild(link);
                        link.href = data.content;
                        link.download = '';
                        link.target = "_blank";
                        link.click();
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'part-sale-invoice-pdf');
                }
            });

        },
        previewInvoice() {
            var self = this;
            self.$router.push('/invoice/part-sale/preview/' + self.invoiceId);
        },
        crmSection() {
            var self = this;
            if (!self.isCrmSection) {
                self.isCrmSection = true;
                self.enableInvoiceCrm = true;
                self.crmBtnTitle = "Detail";
            }else{
                self.isCrmSection = false;
                self.enableInvoiceCrm = false;
                self.crmAdd = false;
                self.crmBtnTitle = "CRM";
            }
        },
        addCrm() {
            var self = this;
            self.crmAdd = true;
            self.invoiceObj.crm_id = "";
            self.invoiceObj.flag = "add";
        },
        cancelCrmFromView() {
            var self = this;
            self.crmAdd = false;
        },
        editCrmFromView(crmId){
            var self = this;
            self.crmAdd = true;
            self.invoiceObj.crm_id = crmId;
            self.invoiceObj.flag = "update";
        },
        backInvoiceList() {
            var self = this;
             var url = '/invoice/list';

            if ( self.fromUrl != ""  ) {
              if(self.from == 'customer'){
                var  selectTab = '?viewTab=invoice';
                url = self.fromUrl+selectTab;
              }else{
                url = self.fromUrl;
              }

            }
            if(this.$route.query.from != undefined && this.$route.query.from == 'gl'){
               self.$router.push('/report/general-ledger');
            }else{
               self.redirectPageUrl(url);
            }

        },
    }

}
</script>



// WEBPACK FOOTER //
// src/components/invoice/PartSaleInvoiceView.vue